export default "__VITE_ASSET__BpyrpQI___"